module.exports = __webpack_public_path__ + "img/coinbase-ui.2753f5df.jpg";